/* eslint-disable no-restricted-imports */
import React, { useRef } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Text,
} from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';
import { ManagedUser } from 'src/api/users';

type DeleteUserDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  user: ManagedUser | null;
  isLoading: boolean;
};

export const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  user,
  isLoading,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  if (!user) return null;

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader
            fontFamily="marketingPage"
            fontWeight="bold"
            fontSize="lg"
            color="text.title">
            Remove User
          </AlertDialogHeader>
          <AlertDialogBody>
            <Text>
              Are you sure you want to remove this user from your team?
            </Text>
            <Text mt={2} color="gray.600" fontSize="sm">
              This action cannot be undone.
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter gap={3}>
            <Button
              ref={cancelRef}
              onClick={onClose}
              buttonName="cancel-delete"
              variant="ghost">
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              isLoading={isLoading}
              buttonName="confirm-delete"
              sx={{
                bg: 'background.red.500',
                color: 'white',
                _hover: { bg: 'red.600' },
              }}>
              Remove User
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
